import React, { Component } from "react";
import { withNavigation } from "../withNavigation";
import "../styles/history.css"

class History extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: null,
      history: [],
      loading: true
    };
  }


  async componentDidMount() {
    const user = localStorage.getItem("user");
    if (!user) {
      this.props.navigate("/", { replace: true });
      return;
    }



    // fetch history
    let userData = this.props.location?.state?.user;

    if (!userData) {
      const storedUser = localStorage.getItem("user");

      if (storedUser) {
        userData = JSON.parse(storedUser);
      }
    }
    if (!userData) {
      this.props.navigate("/", { replace: true });
      return;
    }



    this.setState({ user: userData });

    try {
      const res = await fetch(`https://api.hi-bigame.online/history/${userData.id}`, {
    headers: {"Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  });

      const data = await res.json();

      this.setState({
        history: data,
        loading: false
      });

    } catch {
      this.setState({
        loading: false
      });
    }
  }




  goHome = () => {
    this.props.navigate("/home", {
      state: { user: this.state.user }
    });
  };




  render() {
    return (
      <div className="history-container">

        <div className="history-card">

          <h1 className="history-title">📜 Match History</h1>

          <button className="back-btn" onClick={this.goHome}> Back Home</button>

          {this.state.loading ? (
            <h3>Loading...</h3>
          ) : this.state.history.length === 0 ? (
            <h3>No History Found</h3>
          ) : (

            <table className="history-table">

              <thead>
                <tr>  <th>ID</th> <th>Opponent</th>  <th>Result</th> <th>Entry</th>  <th>Win</th> </tr>
              </thead>

              <tbody>
                {this.state.history.map((item) => (
                  <tr key={item.id}>

                    <td>{item.id}</td>

                    <td>{item.opponent_id}</td>

                    <td  className={ item.result === "WIN"  ? "win"  : "lose" }>{item.result} </td>

                    <td>₹{item.entry_amount}</td>

                    <td>₹{item.win_amount}</td>

                  </tr>
                ))}
              </tbody>

            </table>
          )}

        </div>
      </div>
    );
  }
}

export default withNavigation(History);